module.exports = __webpack_public_path__ + "assets/img/club_profile_my_history.a6dfcc23.jpeg";